module.exports = __webpack_public_path__ + "media/images/game/jidlo-01a9910de0d280ffd38052d69edde2e9.png";